export default "__VITE_ASSET__CgyncCB2__"